/**
 * Mobile sticky CTA for ctr-listicle-banner: shows a fixed duplicate of the
 * main button when the in-flow CTA leaves the viewport and the user has scrolled.
 */
(function () {
  const MOBILE_MQ = '(max-width: 767px)';

  function readScrollThreshold(root) {
    const raw = root.dataset.stickyScrollThreshold;
    const n = raw ? parseInt(raw, 10) : 100;
    return Number.isFinite(n) && n >= 0 ? n : 100;
  }

  function initRoot(root) {
    if (root.dataset.ctrListicleStickyBound === '1') return;
    const stickyWrap = root.querySelector('[data-ctr-listicle-sticky-bar]');
    const mainCta = root.querySelector('[data-ctr-listicle-main-cta]');
    if (!stickyWrap || !mainCta) return;

    root.dataset.ctrListicleStickyBound = '1';

    const mq = window.matchMedia(MOBILE_MQ);
    const scrollThreshold = readScrollThreshold(root);
    let ctaIntersecting = false;

    function setStickyVisible(show) {
      stickyWrap.classList.toggle('is-visible', show);
      stickyWrap.setAttribute('aria-hidden', show ? 'false' : 'true');
    }

    function update() {
      if (!mq.matches) {
        setStickyVisible(false);
        return;
      }
      const y = window.scrollY || window.pageYOffset;
      const shouldShow = !ctaIntersecting && y > scrollThreshold;
      setStickyVisible(shouldShow);
    }

    const io = new IntersectionObserver(
      (entries) => {
        const entry = entries[0];
        if (!entry) return;
        ctaIntersecting = entry.isIntersecting;
        update();
      },
      { threshold: 0, rootMargin: '0px' }
    );

    io.observe(mainCta);
    window.addEventListener('scroll', update, { passive: true });
    mq.addEventListener('change', update);
    update();
  }

  function boot() {
    document.querySelectorAll('.ctr-listicle-banner').forEach(initRoot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
